import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';

import { routes } from './app.routes';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCalAngular } from '@cvx/cal-angular';
import { environment } from '../environments/environment';
import { AppConfig } from './core/services/app-config.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    AppConfig,
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideCalAngular(environment.calConfig),

    provideZonelessChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      RouterModule,
      // Loads CAL configuration and provides CAL services (ConfigService, CalAngularService, RoleGuardService, CalGuardService, etc.)
      // CalAngularModule.forRoot('assets/config.json')

      // Starting with CAL 20, nested config is now supported.
      // The second parameter is the name of the config section.
    ),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor, errorInterceptor])),
    provideAppInitializer(() => {
      const appConfig = inject(AppConfig);
      return appConfig.load();
    }),
  ],
};

/***/
// "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
// "clientId": "4d9db9f1-d2ad-4a86-ade2-cd6ee61829f6",
